import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Seller } from './seller';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * Query Seller (Fisherman) service.
 *
 * @author Warlock, AIS.PL
 */
var QuerySellersService = /** @class */ (function () {
    function QuerySellersService(http) {
        this.http = http;
    }
    QuerySellersService.prototype.querySellers = function (text) {
        var params = new HttpParams();
        if (text !== '') {
            params = params.set('q', String(text));
        }
        return this.http
            .get('fishers/', { headers: { 'Content-Type': 'application/json' }, params: params })
            .pipe(map(function (response) { return response ? response.map(function (element) { return Seller.fromJSON(element); }) : null; }));
    };
    QuerySellersService.ngInjectableDef = i0.defineInjectable({ factory: function QuerySellersService_Factory() { return new QuerySellersService(i0.inject(i1.HttpClient)); }, token: QuerySellersService, providedIn: "root" });
    return QuerySellersService;
}());
export { QuerySellersService };
